import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingService } from '../../_services/loading.service';
import { Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';

@Component({
  imports: [CommonModule],
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class LoadingComponent  implements OnInit, OnDestroy {

  loading: boolean = false;
  loadingSubscription: Subscription;

  constructor(private loadingService: LoadingService) { }

  ngOnInit() {    
    this.loadingSubscription = this.loadingService.loadingStatus.pipe(
      debounceTime(200)
    ).subscribe((value) => {
      this.loading = value;
    });
  }

  ngOnDestroy() {
    /*
     * La guarda `?.` no es cosmetica. loadingSubscription se asigna en ngOnInit, asi que
     * si el componente se destruye sin haber inicializado -navegacion cancelada, o un
     * pase de deteccion de cambios abortado por una excepcion de otro componente- esta
     * linea lanzaba "Cannot read properties of undefined (reading 'unsubscribe')".
     *
     * Es el mismo modo de fallar que el problema de @ViewChild/Ivy: una excepcion dentro
     * de un hook de ciclo de vida, que se lleva por delante el resto del pase. Lo
     * descubrio la primera prueba del shell, que crea el componente y lo destruye sin
     * llamar a detectChanges().
     */
    this.loadingSubscription?.unsubscribe();
  }

}
